(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoOyOService', ReporteEvaluativoOyOService);

    ReporteEvaluativoOyOService.$inject = ['$resource'];

    function ReporteEvaluativoOyOService ($resource) {
        var resourceUrl =  'apo/guardarreporteoo';

        return $resource(resourceUrl, {}, {
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
